import React from "react";

import classnames from "classnames";

import { Typography } from "clearsense-ui/components";

const Cell = ({ percent, count, children, className }) => (
  <td className={classnames("p-6 border border-gray-300", className || "")}>
    <div className="flex flex-col items-start flex-1 w-full h-full">
      <Typography type="semibold" className="mb-2 text-xl">
        {percent}%
      </Typography>
      {children}
      <Typography className="px-2 py-1 mt-4 mr-auto text-xs bg-gray-200 border border-gray-400 rounded-2xl">
        {count} Responses
      </Typography>
    </div>
  </td>
);

export default Cell;
